import {
	COOKIE_LANGUAGE_KEY,
	COOKIE_CATALOG_ID_KEY,
	COOKIE_CATALOG_NAME_KEY,
	COOKIE_THEME_KEY,
	THEME_PREFERENCES,
	CATALOG_NAMES,
	DEFAULT_LANGUAGE,
	LANGUAGE_CODES
} from '@/constants/ui.constants'
import { getURL } from './env.utils'
import { SIDEBAR_COOKIE } from './sidebarLayout.utils'

const COOKIE_DOMAIN = `.${getURL('', '').replace(/^https?:\/\//, '')}`

console.log("SEARCHING COOKIES IN ", COOKIE_DOMAIN)

const VALID_LANGUAGE_CODES = Object.values(LANGUAGE_CODES)

export const setCookie = (key, value) => {
	let newDate = new Date()
	newDate.setTime(newDate.getTime() + (30 * 24 * 60 * 60 * 1000))
	document.cookie = `${key}=${value};path=/;domain=${COOKIE_DOMAIN};expires=${newDate.toUTCString()};`
}

export const cleanCookie = (key) => {
	document.cookie = `${key}=;path=/;domain=${COOKIE_DOMAIN};max-age=0;`
}

export const getCookie = (key) => {
	const cookies = document.cookie
		.split(';')
		.filter((c) => !!c)
		.map((c) => {
			const [name, value] = c.split('=').map((el) => el.trim())
			return { name, value }
		})

	return cookies.find((c) => c.name === key)?.value || null
}

export const setLanguageCookie = (language) => {
	const safeLanguage = VALID_LANGUAGE_CODES.includes(language) ? language : DEFAULT_LANGUAGE
	setCookie(COOKIE_LANGUAGE_KEY, safeLanguage)
}

export const setCatalogIdCookie = (catalogId) => {
	setCookie(COOKIE_CATALOG_ID_KEY, catalogId)
}

export const setCatalogNameCookie = (catalogId) => {
	setCookie(COOKIE_CATALOG_NAME_KEY, CATALOG_NAMES[catalogId].toLowerCase())
}

export const setThemeCookie = (theme) => {
	if (!THEME_PREFERENCES.includes(theme)) return
	setCookie(COOKIE_THEME_KEY, theme)
}

export const getThemeCookie = () => {
	const theme = getCookie(COOKIE_THEME_KEY)
	return THEME_PREFERENCES.includes(theme) ? theme : null
}

// Estado del menú lateral (colapsado + ancho), compartido con professional-area — misma cookie
// de dominio que el tema. La validación/parseo vive en sidebarLayout.utils.
export const setSidebarCookie = (value) => {
	setCookie(SIDEBAR_COOKIE, value)
}

export const getSidebarCookie = () => getCookie(SIDEBAR_COOKIE)
